var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ErrorBoundary',{attrs:{"on-error":_vm.handleError}},[_c('be-dynamic',{attrs:{"page":_vm.page.page,"content":_vm.page.content,"type":_vm.backendLayout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }